import { createContext, Dispatch, SetStateAction } from 'react';

import { CanaryAiEventData } from '@hcs/types';

interface EventDataContextValue {
  event_data: CanaryAiEventData | null;
  setEventData: Dispatch<SetStateAction<CanaryAiEventData | null>>;
}

export const EventDataContext = createContext<EventDataContextValue>({
  event_data: null,
  setEventData: () => void 0,
});
